import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import { InputField, NullableInput } from "../../Shared/InputField"

const BillForm = (props) => {
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const [formData, setFormData] = useState({
        name: "",
        public_id: "",
        public_id2: "",
        year: "",
        month: "",
        previous_reading: "",
        current_reading: "",
        difference: "",
        by: "",
        date: new Date().toISOString().slice(0, 10),
        remark: "",
        serial_number: null,
        zone_id: "",
    })
    const {name, public_id, public_id2, year, month, previous_reading, current_reading,  difference, by, date, remark, serial_number, zone_id} = formData

    const navigate = useNavigate()
    const location = useLocation()

    useEffect (() => {
        if (location.state){
            const {data} = location.state
            setFormData((prev) => ({
                ...prev,
                name: data.name,
                public_id: data.public_id,
                public_id2: data.public_id2,
                year: data.year,
                month: data.month,
                previous_reading: parseInt(data.previous_reading),
                current_reading: "",
                difference: "",
                by: data.by,
                remark: data.remark,
                serial_number: data.serial_number,
                zone_id: data.zone_id
            }))
        }

    }, [location])

    const onChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const paylaod = {public_id, year, month, previous_reading, current_reading, difference, date, remark, serial_number, zone_id}
        addBill(paylaod)
    }
    
    // add bill
    const addBill = async (paylaod) => {
        setIsLoading(true)
        try {
            const response = await Server.post('/un-billed/add-bill', paylaod)
            toast.success(response.data.detail)
            const payload = {
                year: year,
                month: month,
                public_id: public_id2,
                by: by,
                name: name,
            }
            navigate(`/un-billed-${by}`, { state: {payload: payload}})
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else {
                toast.error(error.response?.data?.detail || 'Unkown error')
            }
        }
    }

    const DifferenceKeyUp = (e) => {
        setTimeout(() => {
            if (parseFloat(e.target.value) < (current_reading - previous_reading)){
                // setFormData((prev) => ({
                //     ...prev,
                //     difference: current_reading - previous_reading,
                // }))
                return;
            }
        }, 1000)
    }

    const ReadingKeyUp = (e) => {
        setTimeout(() => {
            if (parseFloat(e.target.value) < previous_reading){
                setFormData((prev) => ({
                    ...prev,
                    current_reading: "",
                    difference: "",
                }))
            }else{
                setFormData((prev) => ({
                    ...prev,
                    difference: current_reading - previous_reading,
                }))
            }
        }, 3000)
    }


    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Add Bill Form</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-4">
                            <InputField
                                name="date"
                                type="date"
                                label="Date"
                                value={date}
                                onChange={onChange}
                                error={errors.date}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                placeholder="Previous Reading"
                                name="previous_reading"
                                type="number"
                                label="Previous"
                                disabled="disabled"
                                value={previous_reading}
                                onChange={onChange}
                                error={errors.previous_reading}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                placeholder="Current Reading"
                                name="current_reading"
                                type="number"
                                label="Current"
                                onKeyUp={ReadingKeyUp}
                                value={current_reading}
                                onChange={onChange}
                                error={errors.current_reading}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <InputField
                                placeholder="Difference"
                                name="difference"
                                type="number"
                                label="Difference"
                                value={difference}
                                onKeyUp={DifferenceKeyUp}
                                onChange={onChange}
                                error={errors.difference}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                placeholder="Remark"
                                name="remark"
                                type="text"
                                label="Remark"
                                value={remark}
                                onChange={onChange}
                                error={errors.remark}
                            />
                        </div>
                        <div className="col-md-4">
                            <NullableInput
                                name="serial_number"
                                type="text"
                                label="Serial Number (Optional)"
                                value={serial_number}
                                onChange={onChange}
                                error={errors.serial_number}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Save Bill" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default BillForm
